import { WikiDeckType, MonsterTokenStyle } from '../../api';
import { CardBackDeck, getCardBackPath } from '../../utils/cardBackArtwork';

const backs: Partial<Record<WikiDeckType, CardBackDeck>> = {
  CommonItems: 'commonItems', UniqueItems: 'uniqueItems', Exhibits: 'exhibits', Spells: 'spells',
  Skills: 'skills', Allies: 'allies', Monsters: 'monsters', Injuries: 'injuries', Madness: 'madnesses',
  Corruptions: 'corruptions', Gates: 'gates', CultEncounters: 'cultEncounters',
};
const artwork: Partial<Record<WikiDeckType, string>> = {
  AncientOnes: '/eye.jpg', Heralds: '/Heralds/The Dark Pharaoh.jpg', Guardians: '/Guardians/Bast.jpg',
  Institutions: '/Guardians/The Bureau of Investigations.jpg', Investigator: '/Investigators/Investigator.png',
  Special: '/icons/Blessing.svg', Relationships: '/Relationship/Relationship.jpg', Mythos: '/TerrorTrack.png',
  Contact: '/Clue.png', InnsmouthLook: '/Innsmouth.jpg', OtherWorld: '/Gate.png',
};
const digitalArtwork: Partial<Record<WikiDeckType, string>> = {
  AncientOnes: '/icons/digital/ancient-eye.webp', Heralds: '/Heralds/rework/small/The Dark Pharaoh.jpg',
  Guardians: '/Guardians/rework/small/Bast.jpg', Contact: '/icons/digital/clue.webp',
  Mythos: '/icons/digital/terror.webp',
  Institutions: '/Institutions/rework/small/TheBureauofInvestigations.jpg',
  Investigator: '/Investigators/tokens/rework/small/Amanda%20Sharpe.jpg',
  Special: '/Special/rework/small/Bless.jpg', InnsmouthLook: '/Expansions/Digital/small/Innsmouth.jpg',
  OtherWorld: getCardBackPath('gates', 'Digital'),
};
export const wikiCategoryArtwork = (deck: WikiDeckType, style: MonsterTokenStyle): string | undefined => {
  const back = backs[deck];
  return back ? getCardBackPath(back, style) : (style === 'Digital' ? digitalArtwork[deck] : undefined) ?? artwork[deck];
};
